var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClockNoBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 17.969a8.717 8.717 0 0 0 8.719-8.719A8.717 8.717 0 0 0 9 .531 8.717 8.717 0 0 0 .281 9.25 8.717 8.717 0 0 0 9 17.969zm0-1.125c-4.173 0-7.594-3.379-7.594-7.594 0-4.173 3.379-7.594 7.594-7.594 4.173 0 7.594 3.379 7.594 7.594 0 4.173-3.379 7.594-7.594 7.594zm2.95-4.581.288-.397a.422.422 0 0 0-.092-.591L9.668 9.471V4.328a.423.423 0 0 0-.422-.422h-.492a.423.423 0 0 0-.422.422V9.94c0 .134.063.26.172.341l2.855 2.074c.19.137.453.095.59-.091z",
    fill: "#1752AF",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockNoBg);
export default __webpack_public_path__ + "static/media/ClockNoBG.51d56b0ded9809e60fa144d4eadc74a8.svg";
export { ForwardRef as ReactComponent };